import clsx from "clsx";
import React from "react";

const ListButton = ({ text, onClick, className = "" }) => {
  return (
    <button
      className={clsx(
        "underline text-xs text-dark-blue-400 px-6 py-2.5 !mt-2",
        className
      )}
      onClick={onClick}
    >
      {text}
    </button>
  );
};

export default ListButton;
